import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUserDashboardData } from "../../redux/slices/userSlice";
import { ApiHandler } from "../../helper/ApiHandler";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import Container from "../../components/Container";
import Breadcrumb from "../../components/Breadcrumb";
import {
  Bike,
  Category,
  Fuel,
} from "../../utils/SvgIcon";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userToken, userDashboard } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userToken) {
      setLoading(true);
      ApiHandler(
        "/dashboard.php",
        "GET",
        undefined,
        userToken,
        dispatch,
        navigate
      )
        .then(
          (res) =>
            res.data.status === "1" &&
            dispatch(setUserDashboardData(res.data.data))
        )
        .catch(() => toast.error("An error occurred. Please try again."))
        .finally(() => setLoading(false));
    }
  }, [userToken, dispatch, navigate]);

  const stats = [
    {
      title: "Total Brands",
      value: userDashboard?.total_brands,
      icon: <Bike />,
      bgColor: "bg-[#FFE2E5]",
    },
    {
      title: "Total Categories",
      value: userDashboard?.total_category,
      icon: <Category />,
      bgColor: "bg-[#FFF4DE]",
    },
    {
      title: "Total Fuel Types",
      value: userDashboard?.total_fuel_type,
      icon: <Fuel />,
      bgColor: "bg-[#F3E8FF]",
    },
  ];

  if (loading) return <Loading />;
  return (
    <>
      <Breadcrumb pageName="Dashboard" />
      <Container>
        <div className="flex min-h-screen p-6">
          <div className="flex-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {stats.map(({ title, value, icon, bgColor }, index) => (
                <div
                  key={index}
                  className={`flex items-center p-7 text-black shadow-lg rounded-2xl transition-transform transform hover:scale-105 ${bgColor}`}
                >
                  <div className=" text-black rounded-full">{icon}</div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold">{title}</h3>
                    <p className="text-2xl font-bold">{value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Dashboard;
